"use strict";

var _reactGa = require("react-ga");

var _reactGa2 = _interopRequireDefault(_reactGa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.clientEntry = function (args, pluginOptions) {
  // Don't track while developing.
  if (process.env.NODE_ENV === `production`) {
    _reactGa2.default.initialize(pluginOptions.trackingId);
  }
};

exports.onRouteUpdate = function (location) {
  // Don't track while developing.
  if (process.env.NODE_ENV === `production`) {
    _reactGa2.default.set({ page: location.pathname });
    _reactGa2.default.pageview(location.pathname);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-google-analytics/gatsby-browser.js
// module id = ./node_modules/gatsby-plugin-google-analytics/gatsby-browser.js
// module chunks = 11